import styled from "styled-components";
import Recommend from "./Recommend";
import cdImg from "../../img/firms/cd-cele.png";
import cdPoster from "../../img/firms/posters/cd-poster.jpg";
import Fade from 'react-reveal/Fade';
function Recommends(){
    return(
        <div>
            <Title className="h-1 title-padding-1-bottom">
                <Fade top>
                Co o nás klienti říkají
                </Fade>
            </Title>
            <div className="slider">
                <Recommend
                    title="Vytvoření komerční aplikace"
                    description="Systém nám denně udržuje přehled o akcích/eventech, o stavu artiklů na skladě a pomáhá zpětně také k hodnocení pomocí implementovaných statistik. Velmi přehledně tak máme přehled o tom, kde a jak je náš marketingový materiál využíván.“"
                    company="České dráhy"
                    author="Robert Pagan"
                    authorPosition="marketing a komunikace"
                    img={cdImg}
                    altImg="Západočeská Univerzite Plzeň"
                    poster={cdPoster}
                    altPoster="Západočeská Univerzite Plzeň"
                />
            </div>
        </div>
    );
}
const Title = styled.div`
  text-align: center;
`;
export default Recommends;